<sbnb-signup-wizard-template>
  <ng-container left-side>
    <h1 class="mb-8 text-2xl md:text-3xl">Enter your mobile number for a link to download our app</h1>

    <p class="mb-6">
      We'll send you a one-time password to verify it's you.
    </p>

    <form [formGroup]="form">
      <label class="text-sm font-bold block text-night" for="phone">Mobile number</label>
      <mat-form-field class="w-full">
        <ngx-mat-intl-tel-input
          [enablePlaceholder]="true"
          [preferredCountries]="signupUserService.preferredCountries$.value"
          [enableSearch]="true"
          name="phone"
          #phone
          formControlName="phone"></ngx-mat-intl-tel-input>
        <mat-hint>Eg. {{ phone.selectedCountry.placeHolder }}</mat-hint>
      </mat-form-field>

      <sbnb-button
        class="block mt-8"
        [fullWidth]="true"
        [loading]="loading"
        [disabled]="form.invalid"
        (clicked)="onContinue()">
        Continue
      </sbnb-button>
    </form>
  </ng-container>

  <img right-side src="/assets/images/signup/start.svg" />
</sbnb-signup-wizard-template>
